import { FETCH_ORDERS_FAILURE,FETCH_ORDERS_SUCCESS, FETCH_ORDERS_REQUEST } from "../actions/orderActions";
const initialState = {
    orders: [],
    currentPage: 1,
    totalPages: 1,
    loading: false,
    error: null,
  };
  
  export const orderReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ORDERS_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_ORDERS_SUCCESS:
        return {
          ...state,
          loading: false,
          orders: action.payload.orders,
          totalPages: action.payload.totalPages,
        };
      case FETCH_ORDERS_FAILURE:
        return { ...state, loading: false, error: action.payload.error };
      default:
        return state;
    }
  };